export default __webpack_public_path__ + "static/media/icon-favourite-remove.31f2c468.svg";